import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { LivingLinkApp } from "./LivingLinkApp";

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <LivingLinkApp />
  </StrictMode>,
);
